import { FC } from 'react';
import { StatusPill } from '@dynamika-shared/ui/StatusPill/StatusPill';
import { SubjectStatus } from '@dynamika-shared/types/subjects';

interface UploadsHeaderProps {
  visitName: string;
  visitStatus: SubjectStatus;
}

export const UploadsHeader: FC<UploadsHeaderProps> = ({ visitName, visitStatus }) => {
  return (
    <div className='flex justify-between items-center  mb-4'>
      <h2 className='text-2432 font-semibold'>
        {visitName}
      </h2>
      <div className='flex items-center'>
        <span className='text-1624 mr-1 text-dimGray'>Status:</span>
        <StatusPill status={visitStatus} textCombiner={' '} />
      </div>
    </div>
  );
};
